const wx = require('weixin-js-sdk');

export function urlArgs() {
  let args: any = {};
  let query = window.location.search.substring(1);
  let pairs = query.split("&");
  for (let i = 0; i < pairs.length; i++) {
    let pos = pairs[i].indexOf("=");
    if (pos === -1) continue;
    let name = pairs[i].substring(0, pos);
    let value = pairs[i].substring(pos + 1);
    value = decodeURIComponent(value);
    args[name] = value;
  }
  return args;
}


export function removeCookie(name: string, path = "/", domain?: string) {
  const domainPart = domain ? `; domain=${domain}` : "";
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${domainPart}`;
}

// 清空当前页面可通过 JS 读到的 cookie（HttpOnly 等无法通过脚本清除）
export function delAllCookie() {
  const host = window.location.hostname;
  document.cookie.split(";").forEach((c) => {
    const name = (c.split("=")[0] || "").trim();
    if (!name) return;
    removeCookie(name, "/");
    removeCookie(name, "/", host);
    removeCookie(name, "/", `.${host}`);
  });
}


// 返回小程序
export function miniBack() {
  if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
    wx.miniProgram.getEnv((res: any) => {
      if (res.miniprogram) {
        // 在小程序环境下
        wx.miniProgram.navigateBack({
          delta: 1,
          // fail: () => {
          //   wx.miniProgram.switchTab({
          //     url: "/pages/index/index"
          //   })
          // },
          complete: (e: any) => {
            wx.miniProgram.switchTab({
              url: "/pages/index/index"
            })
          }
        });

      }
    })
  }
}

/**
 * 检查角色权限
 */
export function checkRole(systemPageList:string[]=[], allowRoleList:string[]=[]) {
  let allow = false;
  if(systemPageList.length > 0) {
    for(const name of systemPageList) {
      const find = allowRoleList.find(a=>a===name);
      if(find) {
        allow = true;
        break;
      }
    }
  }

  return allow;
}
